if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() { super(); this._bound = false; this.index = 0; }
      hide() { document.documentElement.style.overflow = this._prevOverflow || ''; super.hide(); }
      show(opener) { super.show(opener); this._prevOverflow = document.documentElement.style.overflow; document.documentElement.style.overflow = 'hidden'; this.initLightbox(opener); }

      sectionId() { return this.id.replace('ProductModal-', ''); }

      currentColor() {
        try {
          var map = document.getElementById('GossVariantColors-' + this.sectionId());
          if (!map) return null;
          var vmap = JSON.parse(map.textContent);
          var host = this.closest('product-info') || document;
          var input = host.querySelector('[name="id"]');
          var vid = input && input.value;
          if (vid && vmap[vid] != null) return vmap[vid];
        } catch (e) {}
        return null;
      }

      initLightbox(opener) {
        this.viewport = this.querySelector('[data-lb-viewport]');
        this.track = this.querySelector('[data-lb-track]');
        if (!this.viewport || !this.track) return;
        var color = this.currentColor();
        var all = Array.prototype.slice.call(this.querySelectorAll('.goss-lb__slide'));
        all.forEach(function (s) {
          var c = s.getAttribute('data-goss-color') || '';
          var hide = color != null && c !== '' && c !== color;
          s.style.display = hide ? 'none' : '';
        });
        this.visible = all.filter(function (s) { return s.style.display !== 'none'; });
        this.buildDots();
        this.bindOnce();
        var mid = opener && opener.getAttribute('data-media-id');
        var idx = this.visible.findIndex(function (s) { return s.getAttribute('data-media-id') === mid; });
        this.goTo(idx < 0 ? 0 : idx, false);
      }

      width() { return this.viewport.clientWidth; }
      clamp(i) { return Math.max(0, Math.min(i, this.visible.length - 1)); }

      setX(px, animate) {
        if (!animate) this.track.style.transition = 'none';
        this.track.style.transform = 'translate3d(' + px + 'px,0,0)';
        if (!animate) { void this.track.offsetWidth; this.track.style.transition = ''; }
      }
      goTo(i, animate) {
        this.index = this.clamp(i);
        this.setX(-this.index * this.width(), animate !== false);
        this.updateUI();
      }

      buildDots() {
        var dots = this.querySelector('[data-lb-dots]');
        if (!dots) return;
        dots.innerHTML = '';
        var self = this;
        this.visible.forEach(function (s, i) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'goss-lb__dot'; b.setAttribute('aria-label', 'Image ' + (i + 1));
          b.addEventListener('click', function () { self.goTo(i, true); });
          dots.appendChild(b);
        });
      }

      updateUI() {
        var dots = this.querySelectorAll('.goss-lb__dot');
        for (var i = 0; i < dots.length; i++) {
          if (i === this.index) dots[i].setAttribute('aria-current', 'true'); else dots[i].removeAttribute('aria-current');
        }
        var prev = this.querySelector('[data-lb-prev]'), next = this.querySelector('[data-lb-next]');
        if (prev) prev.hidden = this.index <= 0;
        if (next) next.hidden = this.index >= this.visible.length - 1;
      }

      bindOnce() {
        if (this._bound) return; this._bound = true;
        var self = this;
        var prev = this.querySelector('[data-lb-prev]'), next = this.querySelector('[data-lb-next]');
        if (prev) prev.addEventListener('click', function () { self.goTo(self.index - 1, true); });
        if (next) next.addEventListener('click', function () { self.goTo(self.index + 1, true); });

        // drag / swipe
        var startX = 0, base = 0, dragging = false;
        var down = function (e) { dragging = true; startX = (e.touches ? e.touches[0].clientX : e.clientX); base = -self.index * self.width(); self.track.classList.add('is-dragging'); };
        var move = function (e) { if (!dragging) return; var x = (e.touches ? e.touches[0].clientX : e.clientX); self.track.style.transform = 'translate3d(' + (base + (x - startX)) + 'px,0,0)'; };
        var up = function (e) { if (!dragging) return; dragging = false; self.track.classList.remove('is-dragging'); var x = (e.changedTouches ? e.changedTouches[0].clientX : e.clientX); var dx = x - startX; var thr = self.width() * 0.15; if (dx <= -thr) self.goTo(self.index + 1, true); else if (dx >= thr) self.goTo(self.index - 1, true); else self.goTo(self.index, true); };
        this.track.addEventListener('mousedown', down); window.addEventListener('mousemove', move); window.addEventListener('mouseup', up);
        this.track.addEventListener('touchstart', down, { passive: true }); this.track.addEventListener('touchmove', move, { passive: true }); this.track.addEventListener('touchend', up);

        // wheel / trackpad: ONE image per gesture, damped (lock prevents skipping multiple)
        var wlock = false;
        this.viewport.addEventListener('wheel', function (e) {
          var d = Math.abs(e.deltaX) > Math.abs(e.deltaY) ? e.deltaX : e.deltaY;
          if (Math.abs(d) < 6) return;
          e.preventDefault();
          if (wlock) return;
          wlock = true; setTimeout(function () { wlock = false; }, 620);
          self.goTo(self.index + (d > 0 ? 1 : -1), true);
        }, { passive: false });

        // keyboard
        this.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowLeft') self.goTo(self.index - 1, true);
          else if (e.key === 'ArrowRight') self.goTo(self.index + 1, true);
        });
        window.addEventListener('resize', function () { self.setX(-self.index * self.width(), false); });
      }
    }
  );
}
